import {StoreStateShape} from '@/redux/store/storeStateTypes';

export const isModalOpenSelector = ({pageNotAccessible: {showModal}}: StoreStateShape) => showModal;
